<template>
  <div class="text-sm">
    <p class="mt-6"><b>2024.11.01</b> - Dungeon Team is BACK.</p>
    <p>
      We're back at it, folks. It's been a crazy, crazy year, but I've ended up with the
      space to go full time at DT again. Steam release coming soon. Stay tuned for
      updates.
    </p>
  </div>
</template>
